<!--begin::Main-->
<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">

    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="masse d-flex align-items-center">
            <h1 class="page-heading mt-0 mb-0"><svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_645_5490)">
                  <path
                    d="M19.3212 8.53108C19.3212 8.82967 19.2787 9.14532 19.2021 9.47803C18.9808 10.3909 18.4701 11.3719 17.7465 12.0288C17.7295 12.0459 17.7125 12.0715 17.687 12.08C17.1848 12.5151 16.5889 12.7966 15.9165 12.7966C15.244 12.7966 14.6482 12.5151 14.146 12.08C14.1205 12.0715 14.1034 12.0459 14.0864 12.0288C13.3629 11.3719 12.8522 10.3909 12.6309 9.47803C12.5543 9.14532 12.5117 8.82967 12.5117 8.53108C12.5117 6.64571 14.0354 5.11865 15.9165 5.11865C17.7976 5.11865 19.3212 6.64571 19.3212 8.53108Z"
                    fill="#265D91" />
                  <path
                    d="M21.0229 17.9152V22.1807C21.0229 23.1191 20.2568 23.8869 19.3205 23.8869H12.511C11.5747 23.8869 10.8086 23.1191 10.8086 22.1807V17.9152C10.8086 16.0384 12.0173 14.443 13.7026 13.8715C13.8729 13.8203 14.0431 13.7691 14.2134 13.735C14.4857 13.6753 14.7751 13.6497 15.0645 13.6497H16.7669C17.0563 13.6497 17.3457 13.6753 17.6181 13.735C17.7884 13.7691 17.9586 13.8203 18.1288 13.8715C19.8142 14.443 21.0229 16.0384 21.0229 17.9152Z"
                    fill="#265D91" />
                  <path
                    d="M26.1311 3.41243C26.1311 5.11011 24.7692 7.67796 22.7263 7.67796C21.9262 7.67796 21.2282 7.28553 20.6835 6.70542C20.4537 6.09118 20.1132 5.54519 19.6706 5.07598C19.4492 4.5044 19.3301 3.92429 19.3301 3.41243C19.3301 1.52706 20.8537 0 22.7348 0C24.616 0 26.1396 1.52706 26.1396 3.41243H26.1311Z"
                    fill="#265D91" />
                  <path
                    d="M27.833 12.7965V17.0621C27.833 18.0005 27.0669 18.7683 26.1306 18.7683H22.7259V17.9152C22.7259 15.6203 21.4235 13.6241 19.5254 12.6259C20.4702 11.4486 20.998 9.90451 21.015 8.61632C21.2959 8.56513 21.5853 8.53101 21.8747 8.53101H23.5771C25.9263 8.53101 27.833 10.442 27.833 12.7965Z"
                    fill="#265D91" />
                  <path
                    d="M12.512 3.41243C12.512 3.92429 12.3928 4.5044 12.1715 5.06745C11.7289 5.54519 11.3884 6.09118 11.1586 6.70542C10.6138 7.28553 9.91582 7.67796 9.1157 7.67796C7.07284 7.67796 5.71094 5.11011 5.71094 3.41243C5.71094 1.52706 7.23457 0 9.1157 0C10.9968 0 12.5205 1.52706 12.5205 3.41243H12.512Z"
                    fill="#265D91" />
                  <path
                    d="M10.818 8.61632C10.8351 9.90451 11.3628 11.4486 12.3076 12.6259C10.4095 13.6241 9.10715 15.6203 9.10715 17.9152V18.7683H5.70238C4.76607 18.7683 4 18.0005 4 17.0621V12.7965C4 10.442 5.90667 8.53101 8.25595 8.53101H9.95834C10.2477 8.53101 10.5371 8.56513 10.818 8.61632Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_645_5490" x="0" y="0" width="31.834" height="31.887"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_645_5490" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_645_5490" result="shape" />
                  </filter>
                </defs>
              </svg>


              Nos consultants
            </h1>
            <div class="tools">
              <div class="dropdown">
                <button class="masse-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_588_1703)">
                      <circle cx="20" cy="18" r="13" fill="white" />
                    </g>
                    <path d="M19.6667 13V23" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <path d="M15 18.3333H25" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <defs>
                      <filter id="filter0_d_588_1703" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dx="1" dy="3" />
                        <feGaussianBlur stdDeviation="4" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_588_1703" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1703" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="downloadCsv()">Télécharger un modèle d'ajout en
                    masse</a>
                  <a class="dropdown-item" (click)="openModalBulk(add_masse)">Ajout en masse</a>
                </div>
              </div>
            </div>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted ">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Nos consultants</li>
            <!--end::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Liste</li>
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <form>
            <div class="card-body">
              <div class="title mb-3 d-flex justify-content-between">
                <h4>{{ freeSearch ? 'Recherche libre ' : 'Recherche avancée' }}</h4>
                <a (click)="displayFreeSearch()" class="action-btn show-more-button">
                  {{ freeSearch ? 'Recherche avancée' : 'Recherche libre' }}
                  <i class="ms-2 fa fa-paper-plane" style="color: #fff;"></i>
                </a>
              </div>
              <div [formGroup]="searchForm" [ngClass]="{'search-free-hide': freeSearch, 'search-free-block': !freeSearch}">
                <div class="tools">
                  <div class="row mb-3">
                    <div class="col-lg-3">
                      <input type="text" id="nom" formControlName="name" class="form-control form-control-solid mb-3"
                        placeholder="Nom et prénom">
                    </div>
                    <div class="col-lg-3">
                      <input type="text" formControlName="post" id="nom" class="form-control form-control-solid mb-3"
                        placeholder="Poste">
                    </div>
                    <div class="col-lg-3">
                      <input type="text" formControlName="manager_name" id="nom"
                        class="form-control form-control-solid mb-3" placeholder="Manager">
                    </div>
  
                    <div class="col-lg-3">
                      <input type="number" id="statut" class="form-control form-control-solid mb-3"
                        placeholder="Expérience min" formControlName="min_experience_years"
                        oninput="validity.valid||(value='0');" min="0">
                    </div>
                    <div class="col-lg-3">
                      <input type="number" id="statut" class="form-control form-control-solid mb-3"
                        placeholder="Expérience max" formControlName="max_experience_years"
                        oninput="validity.valid||(value='0');" min="0">
                    </div>

                                        <div class="col-lg-3">
                      <div class="combined-input mb-3">
                        <!-- <input type="text" oninput="validity.valid||(value='0');" min="0"
                                                  formControlName="tjm_achat" class="nb1" placeholder="TJM (achat)" id="tjm"> -->
                        <input type="number"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('tjm_achat').value = ''}"
                          min="0" formControlName="tjm_achat" class="nb1" placeholder="TJM (achat)" id="tjm">
  
                        <div class="euro">
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
  
                        </div>
                        <input type="number"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('marge_tjm').value = ''}"
                          min="0" formControlName="tjm_achat_range" class="nb2" value="" id="marge_tjm">
  
                        <div class="icon">
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
  
                        </div>
                        <div class="plusetmois">
                          <i class="fa-solid fa-plus-minus"></i>
                        </div>
  
                      </div>
                    </div>
  
                    <div class="col-lg-3">
                      <div class="combined-input mb-3">
                        <input type="number" formControlName="desired_salary"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('Salaire').value = ''}"
                          min="0" class="nb1" placeholder="Salaire" id="Salaire">
                        <div class="euro">
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
  
                        </div>
                        <input type="number" formControlName="desired_salary_range" (input)="onSalaryRangeInput($event)"
                          (change)="alreadyConverted=false"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('marge_tjm').value = ''}"
                          min="0" class="nb2" value="" id="marge_tjm">
  
                        <div class="icon">
                          <svg width="20" height="15" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                              fill="#4B4B4B" />
                            <path
                              d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
                        </div>
                        <div class="plusetmois">
                          <i class="fa-solid fa-plus-minus"></i>
                        </div>
  
                      </div>
                    </div>
                    
                    <div class="col-lg-3">
                      <div class="combined-input mb-3">
                        <input type="number"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('tjm').value = ''}" min="0"
                          formControlName="tjm_vente" class="nb1" placeholder="TJM (vente)" id="tjm">
  
                        <div class="euro">
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
  
                        </div>
                        <input type="number"
                          oninput="if(this.value==='') {this.value=''; document.getElementById('marge_tjm').value = ''}"
                          min="0" formControlName="tjm_vente_range" class="nb2" value="" id="marge_tjm">
  
                        <div class="icon">
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                              fill="#4B4B4B" />
                          </svg>
  
                        </div>
                        <div class="plusetmois">
                          <i class="fa-solid fa-plus-minus"></i>
                        </div>
  
                      </div>
                    </div>
                    
                  </div>
                  <div class="row mb-3" *ngIf="seeMore">

                    <div class="col-lg-3">
                        <ng-select class="mb-3" [items]="clientList"  [clearable]="true"
                        formControlName="client_final_name"  [placeholder]="'Client'"
                        [notFoundText]="'Aucun élément trouvé'">
                    </ng-select>
                    </div>

                    <div class="col-lg-3">
                      <ng-select [items]="skillsList" formControlName="skillsOr" class="mb-3" bindLabel="name_FR"
                        bindValue="name_FR" [multiple]="true" [placeholder]="'Compétences (ou)'"
                        [notFoundText]="'Aucun élément trouvé'" autoComplete>
                      </ng-select>
                    </div>
                    <div class="col-lg-3">
                      <ng-select [items]="skillsList" formControlName="skillsAnd" class="mb-3" [multiple]="true"
                        id="compt" bindValue="name_FR" placeholder="Compétences (et)" bindLabel="name_FR"
                        [notFoundText]="'Aucun élément trouvé'">
                      </ng-select>
                    </div>
                    <div class="col-lg-3">
                      <ng-select (change)="onCountryChange($event);" class="mb-3" [items]="paysList" bindLabel="name"
                        formControlName="destination_country" bindValue="name" [placeholder]="'Pays'" autoComplete
                        [notFoundText]="'Aucun élément trouvé'">
                      </ng-select>
                    </div>
                    <!-- (change)="onMobilityChange('add')" -->
                    <div class="col-lg-3">
                      <ng-select formControlName="mobility" [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" bindValue="name"
                        class="mb-3" [placeholder]="'Mobilité'" [multiple]="true" autoComplete
                        [notFoundText]="'Aucun élément trouvé'">
                      </ng-select>
                    </div>
                    <div class="col-lg-3">
                      <ng-select [items]="contrat" [bindValue]="'id'" [bindLabel]="'name'"
                          [notFoundText]="'Aucun élément trouvé'" [multiple]="true" id="contrat"
                          (change)="searchconsultantesn(1); startSearching = true"
                          formControlName="contract_type" placeholder="contrat souhaité">
                      </ng-select>
                  </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-3">
                      <div class="see-more mb-5">
                        <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de
                          critères de recherche</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             <div [formGroup]="freeSearchForm" >
              <div class="row mb-5">
                <div class="col-lg-6" [ngClass]="{'search-free-hide': !freeSearch, 'search-free-block': freeSearch}">
                  <div class="input-group search-libre">
                    <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="#7E7C7C" />
                      </svg>
                    </span>

                    <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5"
                      placeholder="Rechercher" formControlName="search"
                      (keyup.enter)="searchconsultantesn(1); startSearching = true" />
                    <div class="tooltip-container tooltip-info">
                      <div class="tooltip-trigger"><i class="fa-solid fa-circle-info" style="font-size: 20px;"></i>
                      </div>
                      <div class="tooltip-content">
                        <div class="content">
                          <h4>Opérateur AND :</h4>
                          <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent
                            inclure plusieurs termes.
                          </p>
                          <p>Exemple : software AND engineer renverra des profils qui
                            mentionnent à la fois "software" et "engineer".
                          </p>
                          <h4>Opérateur OR :</h4>
                          <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent
                            inclure l'un des termes.
                          </p>
                          <p>Exemple : sales OR marketing renverra des profils qui mentionnent
                            soit "sales" soit "marketing".
                          </p>
                          <h4>Opérateur NOT :</h4>
                          <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des
                            résultats.
                          </p>
                          <p>Exemple : developer NOT manager renverra des profils qui
                            mentionnent "developer" mais pas "manager".
                          </p>
                          <h4>Guillemets pour une expression exacte :</h4>
                          <p>Utilisez des guillemets pour rechercher une expression exacte.
                          </p>
                          <p>Exemple : "product manager" renverra des profils qui mentionnent
                            exactement "product manager".
                          </p>
                          <h4>Parenthèses pour grouper des opérations :</h4>
                          <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des
                            opérations.
                          </p>
                          <p>Exemple : (sales OR marketing) AND manager renverra des profils
                            qui mentionnent "sales" ou "marketing" et "manager".
                          </p>
                          <h4>Recherche standard :</h4>
                          <p>Si aucun opérateur n'est spécifié dans la recherche, le texte
                            sera interprété comme s'il était entre guillemets.
                          </p>
                          <p>Exemple : La recherche product manager sera traitée comme
                            "product manager", suivant la règle 4.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             </div>
             <div class="row"  [ngStyle]="{'margin-top': !freeSearch ? '0px' : '-76px'}">
              <div class="mb-3 search-btn d-flex justify-content-end">
                <div class="align-items-center recherche">
                  <button type="button" class="me-5" (click)="currentPage = 0;searchconsultantesn(); startSearching = true">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="white" />
                    </svg>
                    Rechercher</button>
                </div>
                <div class="resett-btn">
                  <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                    title="Réinitialiser">
                    <a> <img src="/assets/media/icons/reset.png" alt="" width="30px" (click)=" reset()"></a>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </form>
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--begin::Content-->

    <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card content-table pt-10">

          <!--begin::Card header-->
          <div class="d-flex flex-wrap my-1 header-grid mb-10 list-consultant-header">
            <div class="section_title">
              <h1 class="section-heading my-5">Liste des consultants</h1>
              <div class="recherche ">
                <a [routerLink]="['/consultants/ajout-consultant']" class="action-btn show-more-button">
                  + Ajouter un consultant
                </a>
              </div>
            </div>
            <!--begin::Tab nav-->
            <div class="switch d-flex flex-end mt-5">
              <ul class="nav nav-pills" *ngIf="listconsultant && listconsultant.length">
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab"
                    href="#kt_project_targets_card_pane">
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                    data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>
            <!--end::Tab nav-->
            <!--begin::Wrapper-->

            <!--end::Wrapper-->
          </div>

          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0">
            <div class="tab-content">
              <!--begin::Tab pane-->
              <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="col-md-6 col-xxl-4" *ngFor="let consultant of listconsultant">
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="tools">
                      </div>
                      <!--begin::Card body-->
                      <div class="card-body d-flex flex-center flex-column">
                        <div class="tools">
                          <div class="dropdown">
                            <button
                              class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                  fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                              <a class="dropdown-item"
                                [routerLink]="['/candidats/profilecandidatesn',consultant.uuid]">Visualiser</a>
                              <a class="dropdown-item" 
                                (click)="updateNavigation(consultant)"
                              >
                                Modifier
                              </a>
                              <a *ngIf="consultant.clientId2_name !== null" class="dropdown-item"
                                (click)="finmission(consultant.uuid)">Fin mission de consultant
                              </a>

                              <a class="dropdown-item" *ngIf="consultant.clientId2_name === null"
                                style="cursor: not-allowed;">Fin mission de consultant</a>
                              <!-- <a class="dropdown-item" (click)="navigateToSuggestionJobRequest(consultant.id)">Voir
                                suggestion appel d'offre
                              </a>
                              <a class="dropdown-item" (click)="navigateToSuggestionJobOffer(consultant.id)">Voir
                                suggestion offre d'emploi
                              </a> -->
                              <a class="dropdown-item cursor-pointer"
                                (click)="dissocierconsultant(consultant.uuid)">Dissocier consultant
                              </a>



                            </div>
                          </div>
                        </div>
                        <div class="card-body d-flex flex-center flex-column">
                          <div class="symbol symbol-65px symbol-circle mb-5">
                            <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                            <img *ngIf="consultant.image_url && consultant.image_url!='avatar.png'" class="table-img"
                              src="{{urlimage + consultant.image_url}}" alt="" width="50px">
                            <img *ngIf="consultant.image_url && consultant.image_url=='avatar.png'" class="table-img"
                              src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt="" width="50px">
                            <img *ngIf="!consultant.image_url || consultant.image_url==='undefined'" class="table-img"
                              src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt="" width="50px">
                          </div> 
                          <span class="job-title title-esn text-center mb-1" [routerLink]="['/candidats/profilecandidatesn',consultant.uuid]" style="cursor: pointer;">
                            {{consultant.first_name ? consultant.first_name :'---'}} 
                            {{consultant.last_name ? consultant.last_name :'---'}} 
                          </span>
                          <div class="poste">
                            {{consultant.client_final_name ? consultant.client_final_name : '---' }}
                          </div>
                          <div class="info">
                            <div class="type mb-3">
                              <span>Salaire :</span>
                              {{ consultant.consultant_e_s_n_s_Salary && consultant.consultant_e_s_n_s_Salary !== "null" && consultant.consultant_e_s_n_s_Salary !='0' ? consultant.consultant_e_s_n_s_Salary + " €" :
                              '---'}}
                            </div>
                          </div>
                          <div class="experience">
                            <div class="exper mb-3">
                              <span>Expérience :</span>
                              {{
                              consultant.years_of_experience && consultant?.years_of_experience>0 &&
                              consultant?.years_of_experience!=="null" &&
                              consultant?.years_of_experience!='0'
                              ? consultant.years_of_experience
                              : "---"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a [routerLink]="['/candidats/profilecandidatesn',consultant.uuid]">Voir plus</a>
                        </div>
                      </div>
                    </div>
                    <!--end::Card-->
                  </div>
                  <app-empty-state *ngIf="listconsultant && !listconsultant.length"
                  [title]="parentItem"></app-empty-state>
                  <div class="pagination mt-5 pt-5" *ngIf="listconsultant && listconsultant.length">
                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                      [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                      aria-label="Select page">
                    </mat-paginator>
                </div>
                </div>
                <!--end::Row-->
              </div>
              <!--end::Tab pane-->
              <!--begin::Tab pane-->
              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <!--begin::Table-->
                  <div class="table-responsive" id="kt_customers_table" *ngIf="listconsultant && listconsultant.length">
                    <table class="table align-middle gy-5 style-table">
                      <thead>
                        <tr class="text-start text-gray-400 fw-bold  text-uppercase gs-0">
                          <ng-container *ngFor="let item of listNames ;let i =index">
                            <th class="min-w-175px" [ngClass]="{'th-fixed': item === 'Nom'}">
                              <span>{{item}}</span>
                            </th>
                          </ng-container>

                          <th class="min-w-150px stiky-column-action">Actions</th>
                          <th class="min-w-70px stiky-column">
                            <div class="dropdown">
                              <button class="dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                  fill="none">
                                  <g filter="url(#filter0_d_588_1699)">
                                    <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                      shape-rendering="crispEdges" />
                                  </g>
                                  <path
                                    d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                    fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                  <defs>
                                    <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                      <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                      <feOffset dy="4" />
                                      <feGaussianBlur stdDeviation="2" />
                                      <feComposite in2="hardAlpha" operator="out" />
                                      <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                      <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_588_1699" />
                                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                        result="shape" />
                                    </filter>
                                  </defs>
                                </svg>
                              </button>
                              <div class="dropdown-table">
                                <div class="dropdown-menu list-actions-content" aria-labelledby="dropdownMenuButton">
                                  <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                    <div class="form-check form-check-sm form-check-custom form-check-solid"
                                      *ngIf="item.name!='checkbox'">

                                      <input class="form-check-input checkbox-border"
                                        [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                        (change)="changeSelectionElement($event,item,i)" type="checkbox" value="1"
                                        [disabled]="item.name==='Image' || item.name==='Nom'" />
                                      <a class="dropdown-item">{{item.name}}</a>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </th>

                        </tr>
                      </thead>
                      <tbody class="fw-semibold text-gray-600">
                        <tr *ngFor="let consultant of listconsultant">
                          <td *ngIf="listNames.includes('Image')">
                            <img *ngIf="consultant.image_url && consultant.image_url!='avatar.png'"
                              class="table-img circle-img" src="{{urlimage + consultant.image_url}}" alt=""
                              width="50px">
                            <img *ngIf="consultant.image_url && consultant.image_url=='avatar.png'"
                              class="table-img circle-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}"
                              alt="" width="50px">
                            <img *ngIf="!consultant.image_url || consultant.image_url==='undefined'"
                              class="table-img circle-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}"
                              alt="" width="50px">

                          </td>
                          <td *ngIf="listNames.includes('Nom')" class="td-fixed">
                            <a class="first-td"
                              [routerLink]="['/candidats/profilecandidatesn',consultant.uuid]">
                              {{consultant.first_name}} {{consultant.last_name}}
                            </a>
                          </td>

                          <td *ngIf="listNames.includes('Poste')">
                            <span class="poste-cont">{{consultant.desired_workstation &&
                              consultant.desired_workstation!=="null" && consultant.desired_workstation!==null
                              ?consultant.desired_workstation
                              : '---' }}</span>
                          </td>
                          <td *ngIf="listNames.includes('Manager')">
                            <span>{{consultant.manager_full_name
                              ?
                              consultant.manager_full_name : '---' }}</span>

                          </td>

                          <td *ngIf="listNames.includes('Client')">
                            <span>
                              {{ consultant.clientId2_name ? consultant.clientId2_name : (consultant.client_final_name ?
                              consultant.client_final_name : "---") }}
                            </span>
                          </td>
                          
                          <td *ngIf="listNames.includes('Date début mission')">
                            <span>
                              {{ consultant.consultant_e_s_n_Mission_start_date  ? 
                                (consultant.consultant_e_s_n_Mission_start_date | date:'dd/MM/yyyy') : "---" }}
                            </span>
                          </td>
                          
                          <td *ngIf="listNames.includes('Date fin mission')">
                            <span>
                              {{ consultant.consultant_e_s_n_Mission_end_date ? 
                                (consultant.consultant_e_s_n_Mission_end_date | date:'dd/MM/yyyy') :  "---" }}
                            </span>
                          </td>
                          <td *ngIf="listNames.includes('Expérience')">

                            <span
                              *ngIf=" consultant?.years_of_experience&&consultant.years_of_experience !== '0 ans'">{{consultant.years_of_experience}}</span>
                            <span
                              *ngIf="!consultant?.years_of_experience || consultant?.years_of_experience === '0 ans' ">---</span>
                          </td>

                          <td *ngIf="listNames.includes('Compétences ')">
                            <ng-container>
                            <div class="skills"  *ngIf="consultant.skills?.length > 0; else emptySkill" placement="top" 
                              [ngbTooltip]="consultant.skills?.length > 3 ? getSkillsList(consultant.skills) : null"
                              >
                              <div
                                class="skill"
                                *ngFor="let skill of consultant.skills?.slice(0, 3); let i = index"
                              >
                                <span [ngClass]="'badge style' + ((i % 3) + 1)">
                                  {{skill}}
                                </span>
                              </div>
                              <div *ngIf="consultant.skills?.length > 3" class="more-icon">
                                <i class="fa fa-ellipsis-h"></i>
                              </div>
                            </div>
                            <ng-template #emptySkill><span>---</span></ng-template>
                         </ng-container>
                        </td>

                        <td *ngIf="listNames.includes('TJM(Achat)')">
                            <span *ngIf="consultant.consultant_e_s_n_s_Tjm_achat && consultant.consultant_e_s_n_s_Tjm_achat !=='null'
                                                            ">{{
                              consultant.consultant_e_s_n_s_Tjm_achat
                              }} &euro;</span>
                            <span *ngIf="!consultant.consultant_e_s_n_s_Tjm_achat || consultant.consultant_e_s_n_s_Tjm_achat ==='null'
                                                                ">---</span>
                          </td>
                          <td *ngIf="listNames.includes('Salaire')">
                            <span
                              *ngIf="consultant.consultant_e_s_n_s_Salary && consultant.consultant_e_s_n_s_Salary!=='null'">{{
                              consultant.consultant_e_s_n_s_Salary}} &euro;</span>
                            <span *ngIf="!consultant.consultant_e_s_n_s_Salary || consultant.consultant_e_s_n_s_Salary==='null'
                                                                ">---</span>
                          </td>
                          <td *ngIf="listNames.includes('TJM(Vente)')">
                            <span *ngIf="consultant.consultant_e_s_n_s_Tjm_vente && consultant.consultant_e_s_n_s_Tjm_vente!=='null'
                            ">{{consultant.consultant_e_s_n_s_Tjm_vente}} &euro;</span>
                            <span *ngIf="!consultant.consultant_e_s_n_s_Tjm_vente || consultant.consultant_e_s_n_s_Tjm_vente==='null'
                                                                ">---</span>
                          </td>
                          <td *ngIf="listNames.includes('Contrat souhaité')">
                            <ng-container>
                              <div class="td-contracts-type" *ngIf="consultant?.desired_contract?.length > 0; else emptyContract" placement="top" 
                                  [ngbTooltip]="consultant.desired_contract?.length > 3 ? getContractTypeList(consultant.desired_contract) : null"
                              >
                                  <div class="td-contracts-item" *ngFor="let contract of consultant.desired_contract | slice:0:3">
                                      <span [ngSwitch]="contract">
                                          <span *ngSwitchCase="1">Alternance</span>
                                          <span *ngSwitchCase="2">Autres type de contrat</span>
                                          <span *ngSwitchCase="3">CDD</span>
                                          <span *ngSwitchCase="4">CDI</span>
                                          <span *ngSwitchCase="5">Freelance</span>
                                          <span *ngSwitchCase="6">Portage salarial</span>
                                          <span *ngSwitchCase="7">Stage</span>
                                      </span>
                                  </div>
                                    <span *ngIf="consultant.desired_contract?.length > 3" class="more-icon">
                                      <i class="fa fa-ellipsis-h"></i>
                                  </span>                                  
                              </div>
                              <ng-template #emptyContract><span>---</span></ng-template>
                          </ng-container>
                            
                          </td>
                          <td *ngIf="listNames.includes('N°Tel')">
                            <span>{{consultant.phone_number ?
                              consultant.phone_number : '---'}}</span>
                          </td>
                          <td *ngIf="listNames.includes('Email')"> <span>{{consultant.email
                              ?
                              consultant.email : '---'}}</span></td>

                          <td *ngIf="listNames.includes('CV')">
                            <a *ngIf="consultant.cv && consultant.cv!=='null'" class="file-cursor"
                              style="cursor: pointer;" (click)="downloadFile('single',consultant)"><svg width="26"
                                height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                  fill="#F58F29" />
                              </svg>
                            </a>
                            <span *ngIf="!consultant.cv || consultant.cv==='null'">---</span>

                          </td>

                          <td *ngIf="1 || listNames.includes('CV WeGestU')">
                            <a class="file-cursor"
                            style="cursor: pointer;"
                            (click)="exportCVCandidate(consultant, 1, null)"><svg
                                width="26" height="26" viewBox="0 0 26 26"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29" />
                            </svg>
                            </a>

                          </td>

                          <td *ngIf="listNames.includes('Score wegestu')">
                            <ng-container *ngIf="consultant?.score !== null; else noScore">
                              <div class="d-flex align-items-center flex-column mt-3 w-100">
                                <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                                  <span class="fw-bold fs-6 text-gray-400">
                                    {{ consultant.score + '%' }}
                                  </span>
                                </div>
                                <div class="h-8px mx-3 w-100 bg-light-success rounded">
                                  <div
                                    class="bg-success rounded h-8px"
                                    role="progressbar"
                                    [style.width.%]="consultant.score"
                                    aria-valuemin="0"
                                    aria-valuemax="100">
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noScore>
                              <span>---</span>
                            </ng-template>
                          </td>
                          <td *ngIf="listNames.includes('Réponses')">
                            <a *ngIf="consultant?.file_test" style="cursor: pointer;"
                              (click)="downloadFile('single',consultant,'response')" class="file-cursor"><svg width="26"
                                height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                  fill="#F58F29" />
                              </svg>
                            </a>
                            <span *ngIf="!consultant.file_test">---</span>
                          </td>
                          <td *ngIf="listNames.includes('Dernière connexion')"> <span> {{
                              !consultant.last_connection ? '---'
                              :consultant.last_connection.split('
                              ')[0].split('-').reverse().join('/') }}
                            </span>
                          </td>
                          <td class="actions td-fixed-3">
                            <div class="tools">
                              <div class="dropdown">
                                <button mat-button [matMenuTriggerFor]="menu"
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                  type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false">
                                  <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                      fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                  </svg>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <button mat-menu-item
                                    [routerLink]="['/candidats/profilecandidatesn',consultant.uuid]">Visualiser</button>
                                    <button mat-menu-item 
                                      (click)="updateNavigation(consultant)">
                                      Modifier
                                  </button>

                                  <button mat-menu-item *ngIf="consultant.clientId2_name !== null"
                                    (click)="finmission(consultant.uuid)">Fin mission de consultant
                                  </button>

                                  <button mat-menu-item *ngIf="consultant.clientId2_name === null"
                                    style="cursor: not-allowed;">Fin mission de consultant</button>

                                  <!-- @TEMPORARY : temporary hidden -->
                                  <!-- <a class="dropdown-item" (click)="navigateToSuggestionJobRequest(consultant.id)">Voir
                                    suggestion appel d'offre
                                  </a>
                                  <a class="dropdown-item" (click)="navigateToSuggestionJobOffer(consultant.id)">Voir
                                    suggestion offre d'emploi
                                  </a>
                                   -->
                                   <button mat-menu-item
                                    (click)="dissocierconsultant(consultant.uuid)">Dissocier
                                    consultant</button>
                                  </mat-menu>
                              </div>
                            </div>

                          </td>
                          <td class="td-fixed-4"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--end::Table-->
                  <app-empty-state *ngIf="listconsultant && !listconsultant.length"
                                    [title]="parentItem"></app-empty-state>
                    <div class="pagination mt-5 pt-5" *ngIf="listconsultant && listconsultant.length">
                      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                        [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                        aria-label="Select page">
                      </mat-paginator>
                  </div>
                </div>
              </div>
              <!--end::Tab pane-->
            </div>
            <!--end::Table-->
           
          </div>
          
          <!--end::Card body-->
        </div>
        <!--end::Card-->
        <!--begin::Modals-->
        <!--begin::Modal - Customers - Add-->

        <!--end::Modal - Customers - Add-->
        <!--begin::Modal - Adjust Balance-->

        <!--end::Modal - New Card-->
        <!--end::Modals-->


      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <!--begin::Footer-->

  <!--end::Footer-->
  <!--end:::Main-->
</div>
<ng-template #add_masse>
  <div class="modal-content" id="add_masse" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <!--begin::Modal content-->
    <div class="">
      <!--begin::Modal content-->
      <div class="content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="">Ajouter en masse</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" data-bs-dismiss="modal"
            class="btn btn-icon btn-sm btn-active-icon-primary">
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
          <!--begin::Form (keyup.enter)="login()"-->
          <label for="masse">Votre ficher CSV</label>
          <input type="file" name="masse" id="masse" class="form-control" (change)="onFileSelected($event)">

          <span style="color:red" *ngIf="fileExtentions"><small>{{fileExtentions}} </small></span>

          <div class="modal-footer">
            <button type="reset" (click)="closeModal()" id="kt_customers_export_cancel" data-bs-dismiss="modal"
              class="footer-btn annuler me-3">Annuler</button>
            <button [disabled]="fileExtentions!='' || !selectedFile" type="submit" id="kt_customers_export_submit"
              (click)="addBulkCandidates()" class="footer-btn confirmer ">
              <span class="indicator-label">Confirmer</span>
              <span class="indicator-progress">Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
          <!--end::Form-->
        </div>
        <!--end::Modal body-->
      </div>
    </div>
  </div>
</ng-template>
